module.exports = __webpack_public_path__ + "static/media/wink-logo.ec37e499.svg";